import {combineReducers} from 'redux'
import { alloteeReducer } from './allotees/redux'

export const reducers = combineReducers({
    alloteeReducer
})